import { useEffect, useRef, useState } from 'react';

export const useScrollAnimation = (options = {}) => {
  const elementRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        if (options.triggerOnce !== false && elementRef.current) {
          observer.unobserve(elementRef.current);
        }
      } else if (options.triggerOnce === false) {
        setIsVisible(false);
      }
    }, { threshold: 0.1, ...options });

    const currentRef = elementRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [options]);

  return [elementRef, isVisible];
};
export default useScrollAnimation;
